import { z } from 'zod';

export const Icon = z
  .enum([
    'BlueRoundedTriangleSvg',
    'PurpleCircleSvg',
    'GreenCircleOutlineSvg',
    'GreyTriangleCircleCutoutSvg',
    'GreenTriangleTriangleCutoutSvg',
    'BlueCircleTriangleCutoutSvg',
    'OrangeDiamondCircleCutoutSvg',
    'GenderMaleIconSvg',
    'GenderFemaleIconSvg',
    'GenderOtherIconSvg',
  ])
  .describe('Icon');

export type Icon = z.infer<typeof Icon>;

export const Icons = Object.values(Icon.Values);
